import {TranslationObject} from '@colonist/i18n'
import {createExternalImgIn} from '../ui_utils/DomUtils'
import {ViewPopup} from './ViewPopup'

export class ViewPopupPatchNoteImage extends ViewPopup {
    constructor(title: TranslationObject, imagePath: string) {
        super(title, {key: 'strings:colonistCommon.utils.emptyString'}, () => undefined, () => undefined, true, {showXButton: false})

        this.container.classList.add('popup-patch-note-image')

        void this.loadImage(imagePath)
    }

    private async loadImage(imagePath: string) {
        const imageModule = await import(`@static/images/patch_notes/${imagePath}`)
        const imageUrl = imageModule.default
        const altText = ViewPopupPatchNoteImage.getAltText(imagePath)

        createExternalImgIn(this.body, imageUrl, {key: 'strings:colonistCommon.utils.#buffer', options: {value: altText}})

        this.show()
    }

    private static getAltText(imagePath: string): string {
        return imagePath
            .replace(/\.[^.]+$/, '') // Remove extension
            .replace(/[_-]/g, ' ') // Replace underscores/hyphens with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize each word
    }
}

